import { initiateDigitalData, updateDigitalData } from './omintrack';
import { updateCurrentFAQ } from './faqTrack';
export default class Analytics {
    
    constructor() {
        initiateDigitalData();
    }

    trackPage(pageName: string, errorState: string): void {
        // initiateDigitalData(pageName);
        // console.error(`Page is : ${pageName}`);
        
        updateDigitalData(pageName, errorState);       

        updateCurrentFAQ(pageName, errorState);
        
    }
}



// WEBPACK FOOTER //
// ./src/analytics/Analytics.ts